import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {isShownProductsSelector} from "../selectors";
import {toggleProducts} from "../AC/toggle-products";
import ArrowForwardIcon from "@material-ui/icons/ArrowForwardIos";

class Navigation extends Component {
  static propTypes = {
    toggleProducts: PropTypes.func,
    isShownProducts: PropTypes.bool
  };
  toggleProducts = (value) => (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    this.props.toggleProducts(value);
    if (window) {
      window.scrollTo(0, 0);
    }
  };
  render() {
    const {isShownProducts} = this.props;
    return (
      <React.Fragment>
        {isShownProducts ? (
          <a
            href="#"
            className="back-to-product"
            onClick={this.toggleProducts(false)}
          >
            Назад
            <ArrowForwardIcon />
          </a>
        ) : (
          <a
            href="#"
            className="back-to-products"
            onClick={this.toggleProducts(true)}
          />
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    isShownProducts: isShownProductsSelector(state)
  }),
  {
    toggleProducts
  }
)(Navigation);
